export default __webpack_public_path__ + "static/media/moon.c504377f.svg";